import { animate, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from 'app/shared/models/Menus/menus';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss'],
  animations: [
    trigger('menu', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(-200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),
    ]),
    trigger('update', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),
    ]),
  ]
})
export class ParametersComponent extends SubscriptionBaseComponent implements OnInit {

  menu: Menu[];

  showBtnParamMenu: boolean;
  showBtnParamFluxActu: boolean;
  myMenuFluxActu: Menu[];

  constructor(
    private titleService: TitleService,
    public router: Router,
    private userService: UserService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.titleService.title.next('Préférences');
    this.dataService.showBtnParamFluxActu.next(false);
    this.dataService.showBtnParamMenu.next(false);
    this.dataService.isConfirmUpdate.next(false);
    this.getMenu();
    this.initSub();
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.menu = res;
      const array: Menu[] = [];
      this.menu.forEach(item => {
        if (item.menuType === 'Flux Actu') {
          array.push(item);
        }
      });
      this.myMenuFluxActu = array;
    });
  }


  private initSub(): void {
    this.subscription
      .add(
        this.dataService.showBtnParamMenu.asObservable().subscribe(showBtnParamMenu => {
          this.showBtnParamMenu = showBtnParamMenu;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.showBtnParamFluxActu.asObservable().subscribe(showBtnParamFluxActu => {
          this.showBtnParamFluxActu = showBtnParamFluxActu;
          this.cdr.detectChanges();
        })
      );
  }
}
